import { clsx } from 'clsx';
import { EntityTileProps } from '../interfaces/tile';
import { Tooltip } from '../../tooltip/Tooltip';
import { NodeLogo } from '../../shared/components/NodeLogo/NodeLogo';
import styles from './EntityTile.module.scss';

export function EntityTile({ tile }: { tile: EntityTileProps }) {
  return (
    <div data-id='node-inner' className={styles.tileNode}>
      <div className={styles.tileLogoContainer}>
        <NodeLogo
          size={8}
          withContextualBg
          logoURL={tile.thumbnail}
          darkModeLogoURL={tile.darkModeThumbnail || ''}
          title={tile.title}
        />
      </div>

      <div className={clsx('center-flex-row justify-center px-4', styles.textContainer)}>
        <Tooltip dataId={`${tile.id}-title`} enableOnTextOverflow title={tile.title}>
          <span data-id={`${tile.id}-title`} className='text-body-2 text-ellipsis mt-0'>
            {tile.title}
          </span>
        </Tooltip>

        {tile.subtitle ? (
          <span data-id={`${tile.id}-subtitle`} className='text-secondary ml-2'>
            {tile.subtitle}
          </span>
        ) : null}
      </div>
    </div>
  );
}
